export interface AppConfig {
  app: { name: string; description: string };
  api: { baseUrl: string; danmuApi: string };
  websocket: { url: string };
  tcplayer: { licenseUrl: string };
  seo: {
    title: string;
    description: string;
    keywords: string;
    author: string;
    ogImage: string;
  };
  theme: { primaryColor: string; secondaryColor: string; dangerColor: string };
}

export const useProjectConfig = (): AppConfig => {
  const config = useRuntimeConfig();

  return {
    app: {
      name: config.public.appName as string,
      description: config.public.appDescription as string,
    },
    api: {
      baseUrl: config.public.apiBaseUrl as string,
      danmuApi: config.public.danmuApi as string,
    },
    websocket: {
      url: config.public.wsUrl as string,
    },
    tcplayer: {
      licenseUrl: config.public.tcplayerLicenseUrl as string,
    },
    seo: {
      title: config.public.seoTitle as string,
      description: config.public.seoDescription as string,
      keywords: config.public.seoKeywords as string,
      author: config.public.seoAuthor as string,
      ogImage: config.public.seoOgImage as string,
    },
    theme: {
      primaryColor: config.public.themePrimaryColor as string,
      secondaryColor: config.public.themeSecondaryColor as string,
      dangerColor: config.public.themeDangerColor as string,
    },
  };
};
